<p>HOME PAGE</p>
<div class="container">
    <form [formGroup]="userForm" (ngSubmit)="onUpdate()">
      <div class="form-group">
        <label for="id">ID</label>
        <input type="text" id="id" class="form-control" formControlName="id" readonly>
      </div>
      <div class="form-group">
        <label for="email">Email</label>
        <input type="email" id="email" class="form-control" formControlName="email" readonly>
      </div>
      <div class="form-group">
        <label for="firstName">First Name</label>
        <input type="text" id="firstName" class="form-control" formControlName="firstName">
      </div>
      <div class="form-group">
        <label for="lastName">Last Name</label>
        <input type="text" id="lastName" class="form-control" formControlName="lastName">
      </div>
      <button type="submit" class="btn btn-primary">Update</button>
    </form>
  </div>